// extracted by mini-css-extract-plugin
export default {"wrapper":"Clone_wrapper__viE2r","icon":"Clone_icon__7yBWA"};